import React from 'react';

const SafetyTipsText = () => {
  const SafetyTip = ({ number, text, emoji }) => (
    <div style={{ marginBottom: '2rem', fontWeight:'bold'}}>
      <h3>
        {number}. {text} <span style={{ fontFamily: 'AppleColorEmoji' }}>{emoji}</span>
      </h3>
    </div>
  );
    return (
      <div style={{ padding: '1vw', fontFamily: 'NewZen', fontSize: '3.2vw', color: '#1d1a05',  paddingBottom: '1rem'}}>
        <div style={{ marginBottom: '4rem' }}>
          <h1 style={{ fontFamily: 'NewZen-Bold', fontSize: '3.2vw', color: '#1d1a05', textAlign: 'center' }}>
            Stay Safe, Date Smart!
          </h1>
        </div>
  
        <p >
          Welcome to the world of digital dating, where the possibilities are endless, and so are the
          matches! But while you’re out there finding your perfect match, we want to make sure you
          stay safe and sound. Here are some tips to help you swipe, chat, and meet with confidence.
        </p>
  
        <SafetyTip number="1" text="Trust Your Instincts" emoji="💡" />
        <p>
          You’re the expert when it comes to you! If something feels off, trust that gut feeling.
          Whether it’s a weird message or a request that makes you uncomfortable, listen to that
          inner voice. It’s usually right!
        </p>
  
        <SafetyTip number="2" text="Keep Your Personal Info Personal" emoji="🔒" />
        <p>
          Your last name, address, workplace, and even your phone number are details to keep under
          wraps until you really know someone. Start with the basics and keep the mystery alive until
          trust is built.
        </p>
  
        <SafetyTip number="3" text="Stay on the App" emoji="💬" />
        <p>
          In-app messaging is there for a reason—it’s a safe space designed to protect you. Before you
          move to texting or social media, make sure you’re comfortable with the person on the other
          side of the screen.
        </p>
  
        <SafetyTip number="4" text="Do Some Digging" emoji="🕵️‍♀️" />
        <p>
          A little background check never hurt anyone! Search their name, check social media, or do a
          quick Google search. It’s totally okay to verify that they are who they say they are.
        </p>
  
        <SafetyTip number="5" text="Video Chat First" emoji="🎥" />
        <p>
          Before meeting up IRL (in real life), why not have a video date? It’s a great way to get a
          feel for the person and confirm they’re the same cutie from their profile pics. Plus, it’s
          fun!
        </p>
  
        <SafetyTip number="6" text="Meet in Public, Always" emoji="🌍" />
        <p>
          The first few dates should always be in a public place—think cafes, parks, or busy streets.
          It’s safer, and let’s be honest, it gives you an easy exit strategy if things aren’t
          clicking.
        </p>
  
        <SafetyTip number="7" text="Tell a Friend" emoji="🗣️" />
        <p>
          Going on a date? Let someone know! Share the details—where you’re going, who you’re meeting,
          and when you expect to be back. A little heads-up can make a big difference.
        </p>
  
        <SafetyTip number="8" text="Mind Your Drinks" emoji="🍹" />
        <p>
          This one’s key: never leave your drink unattended, and be cautious about accepting drinks
          from someone you’ve just met. Better safe than sorry!
        </p>
  
        <SafetyTip number="9" text="Take It Slow" emoji="🐢" />
        <p>
          No need to rush things. Relationships built on mutual trust take time, so pace yourself and
          enjoy getting to know each other.
        </p>
  
        <SafetyTip number="10" text="Exit Gracefully" emoji="🏃‍♂️" />
        <p>
          If you ever feel unsafe or uncomfortable, don’t hesitate to leave. You don’t owe anyone an
          explanation. Your safety comes first, always.
        </p>
  
        <SafetyTip number="11" text="Report Suspicious Activity" emoji="🚨" />
        <p>
          See something sketchy? Whether it's a fake profile, offensive behavior, or anything that
          raises a red flag, report it to us! We take your safety seriously and will investigate
          promptly.
        </p>
  
        <SafetyTip number="12" text="Protect Your Heart (and Wallet)" emoji="💰" />
        <p>
          Love can be blind, but that doesn’t mean your wallet should be! Keep your personal and
          financial information secure, and be wary of anyone who asks for money or sensitive details
          online.
        </p>
        <SafetyTip number="13" text="Set Your Boundaries" emoji="🚧" />
      <p>
        It’s okay to say no. Whether it’s to meeting up, sharing details, or doing something you’re
        uncomfortable with, setting boundaries is essential to your safety and comfort.
      </p>

      <SafetyTip number="14" text="Be Wary of Long-Distance" emoji="✈️" />
      <p>
        Long-distance relationships can work, but be cautious if someone you’ve just met insists on
        maintaining a relationship exclusively online. Scammers often use this tactic to avoid
        meeting in person.
      </p>

      <SafetyTip number="15" text="Be Careful with Photos" emoji="📸" />
      <p>
        Before you share photos, especially sensitive ones, consider the risks. Once sent, they can
        be shared, copied, or used without your consent. It’s best to avoid sending personal or
        intimate photos online.
      </p>

      <SafetyTip number="16" text="Trust Takes Time" emoji="⌛" />
      <p>
        Don’t feel pressured to trust someone quickly. Trust is earned over time through consistent,
        honest actions. Take things slow and pay attention to any red flags.
      </p>

      <SafetyTip number="17" text="Be Clear About Expectations" emoji="💬" />
      <p>
        Whether you're looking for a serious relationship or just a casual fling, be upfront about
        your intentions. Misaligned expectations can lead to misunderstandings, so communication is
        key.
      </p>

      <SafetyTip number="18" text="Watch for Scammers" emoji="⚠️" />
      <p>
        Be cautious of anyone who seems too good to be true or moves too fast. Scammers often use
        elaborate stories to gain your trust, eventually asking for money or personal information.
        If something feels off, trust your instincts.
      </p>

      <SafetyTip number="19" text="Don’t Share Financial Info" emoji="💳" />
      <p>
        Never share your financial information with someone you’ve met online. Scammers often target
        people on dating platforms to get access to bank accounts, credit card details, or other
        sensitive information.
      </p>

      <SafetyTip number="20" text="Recognize Love Bombing" emoji="💥" />
      <p>
        Be wary of someone who overwhelms you with love, attention, and grand gestures too soon.
        This could be a tactic known as “love bombing,” often used to manipulate or control you.
      </p>

      <SafetyTip number="21" text="Use Strong Passwords" emoji="🔑" />
      <p>
        Use strong, unique passwords for your online accounts, especially your dating profiles. Avoid
        using easily guessable information, like your name or birthdate, as part of your password.
      </p>

      <SafetyTip number="22" text="Beware of Catfishing" emoji="🎭" />
      <p>
        Catfishing happens when someone creates a fake profile to deceive others. If someone seems
        too good to be true or refuses to video chat or meet in person, they may not be who they say
        they are.
      </p>

      <SafetyTip number="23" text="Don’t Ignore Red Flags" emoji="🚩" />
      <p>
        If someone pressures you, gets angry at your boundaries, or behaves inconsistently, don’t
        ignore the signs. These red flags can indicate potentially harmful behavior.
      </p>

      <SafetyTip number="24" text="Keep Conversations Balanced" emoji="🔄" />
      <p>
        If the conversation is always about them and they show little interest in you, it might be a
        sign that they’re self-centered or not serious about getting to know you.
      </p>

      <SafetyTip number="25" text="Stay Anonymous Until You’re Ready" emoji="👤" />
      <p>
        On dating apps, you can keep certain details—like your last name or phone number—private
        until you feel comfortable sharing. Protect your privacy until you’re sure you can trust the
        other person.
      </p>

      <SafetyTip number="26" text="Avoid Oversharing" emoji="🤐" />
      <p>
        It’s easy to overshare when you’re excited about someone new, but be careful with the
        personal details you reveal, especially early on. Keep some things to yourself until trust
        is established.
      </p>

      <SafetyTip number="27" text="Keep a Backup Plan" emoji="📱" />
      <p>
        When meeting someone for the first time, have a backup plan in case things don’t go as
        expected. Share your location with a friend or set a time for someone to check in with you.
      </p>

      <SafetyTip number="28" text="Don’t Be Afraid to Block" emoji="🚫" />
      <p>
        If someone makes you uncomfortable or crosses a line, don’t hesitate to block or report
        them. Your well-being is more important than being polite.
      </p>

      <SafetyTip number="29" text="Watch Out for Jealousy" emoji="👀" />
      <p>
        Early signs of jealousy or possessiveness can be a red flag. If someone you’ve just met is
        overly protective or controlling, take a step back and reassess the situation.
      </p>

      <SafetyTip number="30" text="Take Breaks" emoji="⏸️" />
      <p>
        Dating can be exciting, but it can also be overwhelming. If you’re feeling burnt out or
        pressured, take a break. Your mental and emotional health comes first.
      </p>

      <SafetyTip number="31" text="Protect Your Devices" emoji="📱" />
      <p>
        Keep your phone and computer secure by using antivirus software and avoiding suspicious
        links. Hackers often target dating app users, so stay vigilant about protecting your
        devices.
      </p>

      <SafetyTip number="32" text="Be Careful About Linking Social Media" emoji="🔗" />
      <p>
        Avoid linking your dating profile to your social media accounts. This can make it easier for
        someone to gather too much information about you too quickly.
      </p>

      <SafetyTip number="33" text="Stay Sober on First Dates" emoji="🍷" />
      <p>
        While it’s tempting to have a drink or two on a first date, staying sober will help you stay
        alert and aware of the other person’s behavior. You can always grab a drink on the second
        date if things go well.
      </p>

      <SafetyTip number="34" text="Don’t Let Flattery Blind You" emoji="🥰" />
      <p>
        Compliments are nice, but don’t let them cloud your judgment. Scammers and manipulators
        often use excessive flattery to win you over quickly.
      </p>

      <SafetyTip number="35" text="Stick to Daytime Dates" emoji="🌞" />
      <p>
        If you’re unsure about someone, schedule your first few dates during the day. It’s easier to
        stay safe when you’re meeting in public, well-lit places.
      </p>

      <SafetyTip number="36" text="Have Fun, but Stay Safe!" emoji="🎉" />
      <p>
        Dating should be enjoyable, so have fun with it! Just remember to keep these safety tips in
        mind to protect yourself while you meet new people and explore potential relationships.
      </p>

      </div>
    );
  };
  

export default SafetyTipsText;
